import { ArrowUpRight } from "lucide-react";
import { useContent } from "@/lib/content";
import { Media, SmartLink } from "./Media";
import { Reveal } from "./Reveal";

const initials = (n) => n.split(" ").map((x) => x[0]).join("").slice(0, 2).toUpperCase();

export const Team = () => {
  const t = useContent().data.team;
  if (!t?.members?.length) return null;
  return (
    <section className="section team" id="team" data-testid="team-section">
      <div className="wrap">
        <Reveal>
          <p className="eyebrow">{t.eyebrow}</p>
          <h2 className="team-title">{t.title}</h2>
          {t.text && <p className="team-lead">{t.text}</p>}
        </Reveal>
        <div className="team-grid">
          {t.members.map((m, i) => (
            <Reveal key={`${m.name}-${i}`} delay={i * 0.08}>
              <article className="member" data-testid={`team-member-${i}`}>
                <div className="member-photo">
                  {m.image ? <Media src={m.image} alt={m.name} w={600} /> : <span className="member-initials">{initials(m.name || "W M")}</span>}
                </div>
                <h3 data-testid={`team-member-${i}-name`}>{m.name}</h3>
                <p className="member-role">{m.title}</p>
                <p className="member-bio">{m.bio}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export const Promo = () => {
  const p = useContent().data.promo;
  if (!p?.enabled || (!p.title && !p.media)) return null;
  return (
    <section className="promo" data-testid="promo-section">
      <div className="promo-media"><Media src={p.media} alt={p.title} w={1200} testId="promo-media" /></div>
      <div className="promo-copy">
        <Reveal>
          <p className="eyebrow">{p.eyebrow}</p>
          <h2>{p.title}</h2>
          <p>{p.text}</p>
          <SmartLink to={p.link_url} className="btn gold" testId="promo-link-button">{p.link_label || "Learn more"} <ArrowUpRight size={14} /></SmartLink>
        </Reveal>
      </div>
    </section>
  );
};
